module.exports = __webpack_public_path__ + "img/6B3822_A65D48_824E48_401E0C-256px.983dae2c.png";